import { ExternalLink, GitPullRequest, GitCommitHorizontal, History } from "lucide-react";
import { ProviderIcon } from "@/components/brand-icons";

export function PushHistory({ pushes = [] }) {
  if (!pushes.length) {
    return (
      <div className="rounded-md border border-dashed border-slate-300 bg-white p-12 text-center" data-testid="push-history-empty">
        <History className="mx-auto h-8 w-8 text-slate-300" />
        <h3 className="mt-4 font-display text-lg font-semibold">No push yet</h3>
        <p className="mt-1 text-sm text-slate-500">Use "Push to Git" to send this project to a repository. Every push will be listed here.</p>
      </div>
    );
  }
  return (
    <div className="overflow-hidden rounded-md border border-slate-200 bg-white">
      <table className="w-full text-sm" data-testid="push-history-table">
        <thead className="bg-slate-50 text-left text-xs uppercase tracking-widest text-slate-500">
          <tr>
            <th className="px-5 py-3 font-medium">When</th>
            <th className="px-5 py-3 font-medium">Author</th>
            <th className="px-5 py-3 font-medium">Repository</th>
            <th className="px-5 py-3 font-medium">Branch</th>
            <th className="px-5 py-3 font-medium">Commit</th>
            <th className="px-5 py-3 font-medium">Pull request</th>
          </tr>
        </thead>
        <tbody>
          {pushes.map((p, i) => (
            <tr key={`${p.commit_sha}-${p.at}`} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`push-row-${i}`}>
              <td className="px-5 py-3 font-mono-tight text-xs text-slate-600">{new Date(p.at).toLocaleString()}</td>
              <td className="px-5 py-3">
                <div className="text-slate-900">{p.by_name || p.by}</div>
                {p.by_name && <div className="font-mono-tight text-[10px] text-slate-500">{p.by}</div>}
              </td>
              <td className="px-5 py-3">
                <a href={p.tree_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 font-mono-tight text-xs text-slate-900 hover:underline" data-testid={`push-repo-link-${i}`}>
                  <ProviderIcon provider={p.provider} className="h-3.5 w-3.5" /> {p.repo}
                  <ExternalLink className="h-3 w-3 text-slate-400" />
                </a>
                {p.repo_created && <span className="ml-2 rounded-full bg-emerald-50 px-1.5 py-0.5 font-mono-tight text-[9px] uppercase tracking-widest text-emerald-700">created</span>}
              </td>
              <td className="px-5 py-3 font-mono-tight text-xs text-slate-700">{p.branch}</td>
              <td className="px-5 py-3">
                <span className="inline-flex items-center gap-1 font-mono-tight text-xs text-slate-700"><GitCommitHorizontal className="h-3.5 w-3.5 text-slate-400" /> {p.commit_sha?.slice(0, 8)}</span>
                <span className="ml-2 font-mono-tight text-[10px] text-slate-400">{p.files} files</span>
              </td>
              <td className="px-5 py-3">
                {p.pr_url ? (
                  <a href={p.pr_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 font-mono-tight text-xs text-emerald-800 hover:underline" data-testid={`push-pr-link-${i}`}>
                    <GitPullRequest className="h-3.5 w-3.5" /> #{p.pr_number} → {p.base_branch}
                  </a>
                ) : (
                  <span className="font-mono-tight text-xs text-slate-400">—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
